import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import {useCallback, useEffect, useState} from "react";
import {toast} from "react-toastify";
import InterlocutorService from "../../../services/interlocutor.service";
import interlocutorTypeService from "../../../services/interlocutorType.service";
// import {convertDate} from "../../../helpers/utils";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    paddingBottom: '10px'
};

const inputStyle = {
    marginBottom: '15px'
}

const identificationTypes = ['CC', 'NIT'];

const InterlocutorModal = props => {

    const isCreateModal = props.modalType === 'CREATE';
    const [interlocutor, setInterlocutor] = useState({...props.interlocutor});
    const [interlocutorTypes, setInterlocutorTypes] = useState([]);

    const MODAL_TITLE = isCreateModal ? 'Crear Interlocutor' : 'Editar Interlocutor'
    const MODAL_CONFIRM_BUTTON = isCreateModal ? 'Crear' : 'Guardar'

    const inputChangeHandler = e => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        setInterlocutor(interlocutor => {
            return {
                ...interlocutor,
                [name]: value
            }
        })
    }

    const submitInterlocutorHandler = async e => {
        e.preventDefault();
        try {
            if (isCreateModal) {
                await InterlocutorService.createInterlocutor(interlocutor);
            } else {
                await InterlocutorService.updateInterlocutor(interlocutor);
            }

            const successMessage = isCreateModal ? 'Se ha creado correctamente' : 'Se ha actualizado correctamente';
            toast.success(successMessage, {delay: 200});
            closeModalHandler();
        } catch (e) {
            console.error(e);
            toast.error('Ocurrió un error, vuelva a intentar', {delay: 200});
        }
    }

    const fetchInterlocutorTypesHandler = useCallback(async () => {
        try {
            const interlocutorTypeList = await interlocutorTypeService.getActiveInterlocutorTypes();
            setInterlocutorTypes(interlocutorTypeList);
        } catch (error) {
            console.error(error.message);
        }
    }, []);

    useEffect(() => {
        if(props.open) setInterlocutor({...props.interlocutor})
    }, [props.interlocutor, props.open]);

    useEffect(() => {
        void fetchInterlocutorTypesHandler();
    }, [fetchInterlocutorTypesHandler])

    const closeModalHandler = () => props.onClose();

    return (
        <Modal
            open={props.open}
            onClose={closeModalHandler}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2" sx={{marginBottom: '30px'}}>
                    {MODAL_TITLE}
                </Typography>
                <form onSubmit={submitInterlocutorHandler}>
                    <TextField name="name" label="Nombre"
                               variant="outlined"
                               size="small"
                               value={interlocutor.name}
                               onChange={inputChangeHandler}
                               fullWidth
                               sx={inputStyle}/>
                    <TextField
                        name="identificationType"
                        select
                        label="Tipo de Identificación"
                        value={interlocutor.identificationType}
                        onChange={inputChangeHandler}
                        variant="outlined"
                        fullWidth
                        size="small"
                        sx={inputStyle}
                    >
                        {identificationTypes.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField name="identification" label="Identificación"
                               variant="outlined"
                               size="small"
                               value={interlocutor.identification}
                               onChange={inputChangeHandler}
                               fullWidth
                               sx={inputStyle}/>
                    <TextField name="startDate"
                               label="Fecha de Inicio"
                               variant="outlined"
                               size="small"
                               type="date"
                               value={interlocutor.startDate}
                               onChange={inputChangeHandler}
                               fullWidth
                               sx={inputStyle}/>
                    <TextField
                        name="interlocutorTypeId"
                        select
                        label="Tipo de interlocutor"
                        onChange={inputChangeHandler}
                        value={interlocutor.interlocutorTypeId}
                        variant="outlined"
                        fullWidth
                        size="small"
                        sx={inputStyle}
                    >
                        {interlocutorTypes.map((interlocutorType) => (
                            <MenuItem key={interlocutorType.id} value={interlocutorType.id}>
                                {interlocutorType.type}
                            </MenuItem>
                        ))}
                    </TextField>
                    {
                        !isCreateModal &&
                        <TextField name="active"
                                   select
                                   label="Estado"
                                   variant="outlined"
                                   size="small"
                                   fullWidth
                                   value={interlocutor.active ? 1 : 0}
                                   onChange={inputChangeHandler}
                                   sx={inputStyle}>
                            <MenuItem key={1} value={1}>Activo</MenuItem>
                            <MenuItem key={0} value={0}>Inactivo</MenuItem>
                        </TextField>
                    }
                    <Box sx={{float: 'right'}}>
                        <Button variant="outlined" color="error" onClick={closeModalHandler}
                                sx={{marginRight: '10px'}}>Cancelar</Button>
                        <Button variant="contained" type="submit">{MODAL_CONFIRM_BUTTON}</Button>
                    </Box>
                </form>
            </Box>
        </Modal>
    );
}

export default InterlocutorModal;